import { type HTMLAttributes } from 'react';
import { Tag } from 'antd';

export type BadgeTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'primary';

const TONE_COLOR: Record<BadgeTone, string> = {
  neutral: 'default',
  info: 'processing',
  success: 'success',
  warning: 'warning',
  danger: 'error',
  primary: 'blue',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

export function Badge({ tone = 'neutral', children, className, title, ...rest }: BadgeProps) {
  void rest;
  return (
    <Tag color={TONE_COLOR[tone]} className={className} title={title} style={{ marginInlineEnd: 0 }}>
      {children}
    </Tag>
  );
}
